import { isObject } from '@shared/utils';
import buildThreadContentItems from '@/lib/threads/buildThreadContentItems.js';
import normalizeThreadItems from '@/lib/threads/normalizeThreadItems.js';
const PERSIST_TRANSFORM_ARTIFACT_KEYS = new Set(['threadContent']);
const LEGACY_PIEVE_KEYS = ['selectedThreadId', 'threadMetaById', 'threadCollectionsByScope', 'threadsByProject', 'threadsByType', 'triggerRunThreadsByTriggerId', 'scheduleRunThreadsByScheduleId'];

const stripPersistTransformArtifacts = (value) => {
  if (!isObject(value)) {
    return value;
  }

  const nextValue = {
    ...value
  };

  for (const key of PERSIST_TRANSFORM_ARTIFACT_KEYS) {
    delete nextValue[key];
  }

  return nextValue;
};

const normalizePersistedThreads = ({ threads, fallbackThreadMetaById }) => {
  return normalizeThreadItems({
    threads: stripPersistTransformArtifacts(threads),
    fallbackThreadMetaById: stripPersistTransformArtifacts(fallbackThreadMetaById)
  });
};

const normalizePersistedObjectMap = (value) => {
  if (!isObject(value)) {
    return undefined;
  }

  return stripPersistTransformArtifacts(value);
};

const normalizePersistedChangesQueue = (value) => {
  const sourceItems = Array.isArray(value) ? value : Object.values(stripPersistTransformArtifacts(value) || {});

  return sourceItems.filter((item) => {
    return isObject(item);
  });
};

const migratePersistedPieveStateV2 = (persistedState = {}) => {
  const nextState = {
    ...persistedState,
    threads: normalizePersistedThreads({
      threads: persistedState?.threads,
      fallbackThreadMetaById: persistedState?.threadMetaById
    }),
    knowledge: Array.isArray(persistedState?.knowledge) ? persistedState.knowledge : [],
    changesQueue: normalizePersistedChangesQueue(persistedState?.changesQueue)
  };

  const nextComposerDraftsByContextKey = normalizePersistedObjectMap(persistedState?.composerDraftsByContextKey);
  const nextBillingPlanCatalogSnapshot = normalizePersistedObjectMap(persistedState?.billingPlanCatalogSnapshot);
  const nextBillingPlanSummarySnapshotsByCompanyId = normalizePersistedObjectMap(persistedState?.billingPlanSummarySnapshotsByCompanyId);
  const nextThreadContent = buildThreadContentItems(persistedState?.threadContent);

  delete nextState.sidebar;
  delete nextState.projectMetaById;

  if (nextComposerDraftsByContextKey) {
    nextState.composerDraftsByContextKey = nextComposerDraftsByContextKey;
  } else {
    delete nextState.composerDraftsByContextKey;
  }

  delete nextState.threadFollowUpQueueByThreadId;

  if (nextBillingPlanSummarySnapshotsByCompanyId) {
    nextState.billingPlanSummarySnapshotsByCompanyId = nextBillingPlanSummarySnapshotsByCompanyId;
  } else {
    delete nextState.billingPlanSummarySnapshotsByCompanyId;
  }

  if (nextBillingPlanCatalogSnapshot) {
    nextState.billingPlanCatalogSnapshot = nextBillingPlanCatalogSnapshot;
  } else {
    delete nextState.billingPlanCatalogSnapshot;
  }

  if (nextThreadContent.length > 0) {
    nextState.threadContent = nextThreadContent;
  } else {
    delete nextState.threadContent;
  }

  for (const legacyKey of LEGACY_PIEVE_KEYS) {
    delete nextState[legacyKey];
  }

  return nextState;
};

export default migratePersistedPieveStateV2;
